var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visit",
    attrs: {
      "data-testid": "visit-detail"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.visit) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between",
    attrs: {
      "data-testid": "visit-header"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.visit.type === 'normal') ? [_vm._v("\n              Návštěva " + _vm._s(_vm.visit.date) + " (" + _vm._s(_vm.visit.timeFrom) + " - " + _vm._s(_vm.visit.timeTo) + "): "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.visit.visit_purpose.purpose))])] : (_vm.visit.type === 'task') ? [_vm._v("\n              Úkol " + _vm._s(_vm.visit.date) + ": "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.visit.visit_purpose.purpose))])] : _vm._e(), _vm._v(" "), (_vm.editingVisitId === _vm.visit.id) ? [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.putVisit(_vm.visit)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingVisit.note),
      expression: "editingVisit.note"
    }],
    staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
    attrs: {
      "type": "text",
      "aria-describedby": "noteHelp",
      "id": "note",
      "data-testid": "visit-note-input"
    },
    domProps: {
      "value": (_vm.editingVisit.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editingVisit.note = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "visit-note-save"
    }
  }, [_vm._v("Uložit")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])] : [_c('button', {
    staticClass: "btn btn-sm btn-link text-secondary",
    attrs: {
      "data-testid": "visit-note-edit"
    },
    on: {
      "click": function($event) {
        _vm.editVisit(_vm.visit.note, _vm.visit.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('i', [_vm._v("poznámka: " + _vm._s(_vm.visit.note))])]], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_vm._v("\n            " + _vm._s(_vm._f("stateToCS")(_vm.visit.state)) + "\n            "), (_vm.visit.state !== 'failed' && _vm.visit.state !== 'excused' && _vm.visit.state !== 'completed' && _vm.visit.state !== 'canceled') ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "data-testid": "visit-complete"
    },
    on: {
      "click": _vm.completeVisit
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" dokončit návštěvu")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-header justify-content-between"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'VisitMedicalReport') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'VisitMedicalReport'
      },
      "data-testid": "visit-tab-medical-report"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Lékařská zpráva")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "visit-tab-medical-report"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Lékařská zpráva")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'VisitDiagnosis') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'VisitDiagnosis'
      },
      "data-testid": "visit-tab-diagnosis"
    }
  }, [_c('i', {
    staticClass: "fa fa-stethoscope fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Diagnózy a výkony")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "visit-tab-diagnosis"
    }
  }, [_c('i', {
    staticClass: "fa fa-stethoscope fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Diagnózy a výkony")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'VisitMedicament') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'VisitMedicament'
      },
      "data-testid": "visit-tab-medicament"
    }
  }, [_c('i', {
    staticClass: "fa fa-adjust fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Léky a recepty")]) : _c('span', {
    staticClass: "nav-link active"
  }, [_c('i', {
    staticClass: "fa fa-adjust fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Léky a recepty")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'VisitVoucher') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'VisitVoucher'
      },
      "data-testid": "visit-tab-voucher"
    }
  }, [_c('i', {
    staticClass: "fa fa-crutch fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Poukazy")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "visit-tab-voucher"
    }
  }, [_c('i', {
    staticClass: "fa fa-crutch fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Poukazy")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'VisitDocument') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'VisitDocument'
      },
      "data-testid": "visit-tab-document"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Dokumenty")]) : _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": "visit-tab-document"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Dokumenty")])], 1)])]), _vm._v(" "), _c('router-view')], 1) : (_vm.visitPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n        (načítám)\n      ")]) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3b043c6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/ShowVisit.vue
// module id = 495
// module chunks = 0